export default function normalizeFactorData(factor: Factor) {
    const cond: Cond = {
        title: "currency",
        label: <span className="font-bold">{factor.Currency.en_title}</span>,
        value: "currency",
        type: "price",
    };

    const res: FactorMainData = {
        // accountingCode: factor.accountingCode,
        BranchId: factor.BranchId,
        currencyExchange: factor.currency_exchange,
        currencyId: factor.CurrencyId,
        date: factor.date,
        taxSettlementType:factor.taxSettlementType,
        dueDate: factor.dueDate,
        description: factor.description,
        taxType: factor.taxType,
        factorType: factor.type,
        PersonId: factor.PersonId,
        ProjectId: factor.ProjectId,
        reference: factor.reference,
        SellerId: factor.SellerId,
        sellerCommission: factor.commission,
        commissionType: "number",
        title: factor.title,
        status: factor.status,
        transferPrice: factor.transferPrice,
        SCinput: {val: factor.commission || 0, cond},
    };
    return res;
}
